import React from "react";
import { lifestylePhotos } from "../data/offer";
const closingLines = ["Une parabole aujourd’hui.", "Une conversation demain.", "Et de précieux moments à garder dans le cœur."];
export function EmotionalSection() {
  return <section className="bg-sage-deep text-cream" data-id="element-60" data-mp="3aft4z9yxyifa">
      <div className="mx-auto max-w-6xl px-5 py-20 md:py-28" data-id="element-61" data-mp="3efbsmdi5d7lt">
        <h2 className="mx-auto max-w-4xl text-center font-display text-3xl font-semibold leading-tight md:text-5xl md:leading-[1.1]" data-id="element-62" data-mp="3edqz8r7kjupj">
          Bien plus que des histoires… des souvenirs de foi à créer ensemble.
        </h2>

        <div className="mt-12 grid items-center gap-10 md:mt-16 lg:grid-cols-[1.15fr_1fr] lg:gap-16" data-id="element-63" data-mp="3t4zubfu8q8a2">
          <img src={lifestylePhotos.bedtimeStory} alt="Un papa lit une histoire à ses deux enfants au moment du coucher" className="aspect-[4/3] w-full rounded-[2rem] object-cover" data-id="element-64" data-mp="1y6kjnldt0tx" />
          <div data-id="element-65" data-mp="2mpp2x71eiqqe">
            <p className="text-lg leading-relaxed text-cream/90 md:text-xl" data-id="element-66" data-mp="2mq8ocxq9fx96">
              Un enfant n’a pas besoin d’une leçon parfaite pour découvrir la
              foi. Il a surtout besoin de moments de partage, de questions
              accueillies avec amour et de petites expériences qui donnent du
              sens aux enseignements de la Bible.
            </p>
            <p className="mt-10 space-y-1 font-display text-2xl italic leading-snug md:text-3xl" data-id="element-67" data-mp="2tu1dw1n9umrp">
              {closingLines.map((line, i) => <span key={line} className={`block ${i === closingLines.length - 1 ? "text-blush-light" : ""}`} data-id="element-68" data-mp="37rzg68obisqu" data-mpi={i}>
                  {line}
                </span>)}
            </p>
          </div>
        </div>
      </div>
    </section>;
}